import { VStack, Button } from '@chakra-ui/react';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';

export function SubmitStepButton({ onSubmit, isDisabled = false }: { onSubmit: () => void; isDisabled?: boolean }) {
  const { colors } = useTheme();
  return (
    <VStack justifyContent="flex-start" alignItems="flex-start" marginTop="48px" width="100%">
      <Button
        onClick={onSubmit}
        backgroundColor={colors.primaryColor}
        color={colors.primaryFontColor}
        paddingX={12}
        isDisabled={isDisabled}
      >
        Avançar
      </Button>
    </VStack>
  );
}
